import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import { ItemType } from 'app/common/ui-next/plain-radio-button'
import { OrderByClassesDetailsGroup } from 'app/dataTypes/reports/data/common/ordersByClasses'


export type OrderByClassesDetailsList = Array<ItemType>

class OrderByClassesDataBox extends DataBox<OrderByClassesDetailsList> { }

export const defaultOrderByClasses: OrderByClassesDetailsList = []
export const orderByClassesGroupFilter = createDataBox('orderByClassesGroupFilter', defaultOrderByClasses, OrderByClassesDataBox)

export const defaultOrderByClassesGroupData = () => {
  return [
    {
      id: OrderByClassesDetailsGroup.ByClasses,
      title: 'категориям учащихся и сменам',
    },
    {
      id: OrderByClassesDetailsGroup.ByCustomersAndFunds,
      title: 'по категориям учащихся и виду средств',
    },
    {
      id: OrderByClassesDetailsGroup.ByFunds,
      title: 'виду средств',
    },
  ]
}

orderByClassesGroupFilter.updateData(defaultOrderByClassesGroupData)
orderByClassesGroupFilter.setStatusReady()


export const defaultOrderByClassesFilterSelection: string = OrderByClassesDetailsGroup.ByClasses
export const orderByClassesGroupFilterSelection = createDataBoxDefault<string>('orderByClassesGroupFilterSelection', defaultOrderByClassesFilterSelection)
